import { DOMAIN_TYPES, SOFTPROTO_VALUES } from '@/consts/domains'

export const APP_LANGUAGES_LIST = [
  { value: 'en', label: 'English' },
  { value: 'ar', label: 'Arabic' },
  { value: 'sq', label: 'Albanian' },
  { value: 'bg_BG', label: 'Bulgarian' },
  { value: 'ca', label: 'Catalan' },
  { value: 'zh_CN', label: 'Chinese (Simplified)' },
  { value: 'zh_TW', label: 'Chinese (Traditional)' },
  { value: 'hr', label: 'Croatian' },
  { value: 'cs_CZ', label: 'Czech' },
  { value: 'da_DK', label: 'Danish' },
  { value: 'nl_NL', label: 'Dutch' },
  { value: 'fi', label: 'Finnish' },
  { value: 'fr_FR', label: 'French' },
  { value: 'de_DE', label: 'German' },
  { value: 'el', label: 'Greek' },
  { value: 'he_IL', label: 'Hebrew' },
  { value: 'hu_HU', label: 'Hungarian' },
  { value: 'id_ID', label: 'Indonesian' },
  { value: 'it_IT', label: 'Italian' },
  { value: 'ja', label: 'Japanese' },
  { value: 'ko_KR', label: 'Korean' },
  { value: 'nb_NO', label: 'Norwegian Bokmål' },
  { value: 'fa_IR', label: 'Persian' },
  { value: 'pl_PL', label: 'Polish' },
  { value: 'pt_PT', label: 'Portuguese (Portugal)' },
  { value: 'pt_BR', label: 'Portuguese (Brazil)' },
  { value: 'ro_RO', label: 'Romanian' },
  { value: 'ru_RU', label: 'Russian' },
  { value: 'sl_SI', label: 'Slovenian' },
  { value: 'sk_SK', label: 'Slovak' },
  { value: 'es_ES', label: 'Spanish' },
  { value: 'sv_SE', label: 'Swedish' },
  { value: 'th', label: 'Thai' },
  { value: 'tr_TR', label: 'Turkish' },
  { value: 'uk', label: 'Ukrainian' },
  { value: 'vi', label: 'Vietnamese' },
  { value: 'zh_HK', label: 'Chinese (Hong Kong)' },
]

export const appPwdCharset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
export const appUserCharset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'

export const PLATFORM_LOGOS = {
  wp: 'wordpress.svg',
  drupal: 'drupal.svg',
  joomla: 'joomla.svg',
  laravel: 'laravel.svg',
  mediawiki: 'mediawiki.svg',
  prestashop: 'prestashop.svg',
  opencart: 'opencart.svg',
  abantecart: 'abantecart.png',
  dokuwiki: 'default.svg',
  codeigniter: 'codeigniter.svg',
  clientexec: '', // only for main reseller account
  whmcs: 'whmcs.svg', // only for main reseller account
  moodle: 'moodle.svg',
  phpbb: 'phpbb.svg',
}

export const APP_PLATFORMS = Object.keys(PLATFORM_LOGOS)

export const resellerOnly = [
  'clientexec',
  'whmcs',
]

// For subdomains use "https://", for the rest use "https://www.". AM-1024
export const domainTypeProtocolMap = new Map([
  [DOMAIN_TYPES.MAIN, SOFTPROTO_VALUES.https_www.value],
  [DOMAIN_TYPES.SUB, SOFTPROTO_VALUES.https.value],
  [DOMAIN_TYPES.ADDON, SOFTPROTO_VALUES.https_www.value],
])
